/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-use-before-define */
// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
// COMPONENTS
import Accordion from 'react-bootstrap/Accordion';
import Table from 'react-bootstrap/Table';
// ICONS
import {
  HiOutlineTrash,
  HiOutlinePencil,
  // HiPlusCircle
} from 'react-icons/hi';
// CUSTOM COMPONENTS
import CustomBlock from '../../../../components/CustomBlock';
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import ContentHeader from '../../../../components/ContentHeader';
import Overlay from '../../../../components/Overlay';
import ModalBlock from '../../../../components/ModalBlock';
import FormBlock from '../../../../components/FormBlock';
import Button from '../../../../components/Button';
import InputBlock from '../../../../components/InputBlock';
// REDUX
import * as alert from '../../../../redux/alertToastRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import * as helper from '../../../../helpers/helper';
import * as groupService from '../../../../services/management/groupService';
import * as gradeService from '../../../../services/management/gradeService';

const GroupListingPage = (props) => {
  const { auth, showAlert, showConfirmModal, hideConfirmModal } = props;
  const initialGroup = {
    id: 0,
    name: ''
  };
  const initialGrade = {
    id: 0,
    group: '',
    groupId: 0,
    genericGrade: '',
    millGrade: ''
  };
  const [isLoading, setIsLoading] = useState(true);
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [isGradeModalOpen, setIsGradeModalOpen] = useState(false);
  const [groupModel, setGroupModel] = useState(initialGroup);
  const [groups, setGroups] = useState([]);
  const [gradeModel, setGradeModel] = useState(initialGrade);

  useEffect(() => {
    setIsLoading(false);
    getGroups();
  }, []);

  const getGroups = () => {
    setIsLoading(true);

    groupService.getAllGroups('').then((res) => {
      setGroups(res);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const groupFormik = useFormik({
    initialValues: groupModel,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      id: Yup.number(),
      name: Yup.string().required().max(50),
    }),
    onSubmit: (values) => {
      setIsLoading(true);
      if (values.id === 0) {
        createGroup(values);
      } else {
        saveGroup(values);
      }
    },
  });

  const gradeFormik = useFormik({
    initialValues: gradeModel,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      id: Yup.number(),
      groupId: Yup.number().required(),
      genericGrade: Yup.string().required().max(150),
      millGrade: Yup.string().required().max(150),
    }),
    onSubmit: (values) => {
      setIsLoading(true);
      if (values.id === 0) {
        createGrade(values);
      } else {
        saveGrade(values);
      }
    },
  });

  const getGroup = (id) => {
    setIsLoading(true);
    groupService.getGroupById(id).then((res) => {
      setGroupModel(res);
      setIsGroupModalOpen(true);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const createGroup = (model) => {
    groupService.createGroup(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getGroups();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      handleGroupModalClose();
      setIsLoading(false);
    });
  };

  const saveGroup = (model) => {
    groupService.updateGroup(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getGroups();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      handleGroupModalClose();
      setIsLoading(false);
    });
  };

  const deleteGroup = (id) => {
    hideConfirmModal();
    setIsLoading(true);
    groupService.deleteGroup(id).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getGroups();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const getGrade = (id) => {
    setIsLoading(true);
    gradeService.getGradeById(id).then((res) => {
      setGradeModel(res);
      setIsGradeModalOpen(true);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const createGrade = (model) => {
    gradeService.createGrade(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getGroups();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      handleGradeModalClose();
      setIsLoading(false);
    });
  };

  const saveGrade = (model) => {
    gradeService.updateGrade(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getGroups();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      handleGradeModalClose();
      setIsLoading(false);
    });
  };

  const deleteGrade = (id) => {
    hideConfirmModal();
    setIsLoading(true);
    gradeService.deleteGrade(id).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getGroups();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const handleGroupModalClose = () => {
    setIsGroupModalOpen(false);
    setTimeout(() => {
      setGroupModel(initialGroup);
      groupFormik.resetForm();
    }, 250);
  };

  const handleGradeModalClose = () => {
    setIsGradeModalOpen(false);
    setTimeout(() => {
      setGradeModel(initialGrade);
      gradeFormik.resetForm();
    }, 250);
  };

  return (
    <CustomBlock className="content-container--padded">
      {isLoading && <Overlay hasLoader />}
      <Section isFullWidth>
        <ContentBlock>
          <CustomBlock className="content-container--card-style--with-shadow">
            <ContentHeader
              title="Groups"
              headerSize="lg"
              primaryButtonText={auth.accessLevel > 40 ? 'New Group' : ''}
              primaryButtonOnClick={() => {
                setIsGroupModalOpen(true);
              }}
            />

            <Section hasNoContainer>
              {
                groups.length === 0 && (
                  <p>No groups available.</p>
                )
              }
              {
                groups.map((group) => (
                  <ContentBlock cols={4} className="mb-20">
                    <Accordion>
                      <Accordion.Item>
                        <Accordion.Header>{group.name}</Accordion.Header>
                        <Accordion.Body>
                          <Section hasNoContainer>
                            {
                              auth.accessLevel > 40 && (
                                <CustomBlock className="mb-15 flex--between">
                                  <Button
                                    text="Update"
                                    size="xxs"
                                    className="primary--bg mr-5"
                                    onClick={() => {
                                      getGroup(group.id);
                                    }}
                                  />

                                  <Button
                                    text="New"
                                    size="xxs"
                                    className="success--bg mr-5"
                                    onClick={() => {
                                      setGradeModel({
                                        ...gradeModel,
                                        group: group.name,
                                        groupId: group.id
                                      });
                                      setIsGradeModalOpen(true);
                                    }}
                                  />

                                  <Button
                                    text="Delete"
                                    size="xxs"
                                    className="danger--bg"
                                    onClick={() => {
                                      showConfirmModal({
                                        title: 'Delete Group',
                                        text: 'Are you sure you want to remove this group?',
                                        rightBtnText: 'Confirm',
                                        btnAction: () => {
                                          deleteGroup(group.id);
                                        }
                                      });
                                    }}
                                  />
                                </CustomBlock>
                              )
                            }

                            <Table
                              striped
                              bordered
                              hover
                            >
                              <thead>
                                <tr>
                                  {
                                    auth.accessLevel > 40 && (
                                      <th>Actions</th>
                                    )
                                  }
                                  <th>Generic Grade</th>
                                  <th>Mill Grade</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  group.grades.map((grade) => (
                                    <tr>
                                      {
                                        auth.accessLevel > 40 && (
                                          <td>
                                            <CustomBlock className="flex-center">
                                              <Button
                                                iconLeft={<HiOutlinePencil className="white--clr" size={20} />}
                                                size="icon"
                                                className="primary--bg mr-10"
                                                onClick={() => {
                                                  getGrade(grade.id);
                                                }}
                                              />

                                              <Button
                                                iconLeft={<HiOutlineTrash className="white--clr" size={20} />}
                                                size="icon"
                                                className="danger--bg"
                                                onClick={() => {
                                                  showConfirmModal({
                                                    title: 'Delete Grade',
                                                    text: 'Are you sure you want to remove this grade?',
                                                    rightBtnText: 'Confirm',
                                                    btnAction: () => {
                                                      deleteGrade(grade.id);
                                                    }
                                                  });
                                                }}
                                              />
                                            </CustomBlock>
                                          </td>
                                        )
                                      }

                                      <td>{grade.genericGrade}</td>
                                      <td>{grade.millGrade}</td>
                                    </tr>
                                  ))
                                }
                              </tbody>
                            </Table>
                          </Section>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </ContentBlock>
                ))
              }
            </Section>
          </CustomBlock>
        </ContentBlock>
      </Section>

      {/* GROUP MODAL */}
      <ModalBlock
        hasCloseAction
        centered
        isVisible={isGroupModalOpen}
        size="md"
        contentHeader={groupModel.id === 0 ? 'Add New Group' : 'Edit Group'}
        primaryModalActionText={groupModel.id === 0 ? 'Create' : 'Save Changes'}
        primaryModalActionColor="primary--bg"
        primaryModalActionOnClick={groupFormik.handleSubmit}
        secondaryModalActionText="Cancel"
        secondaryModalActionColor="danger--bg"
        onHide={handleGroupModalClose}
      >
        <FormBlock onSubmit={groupFormik.handleSubmit}>
          <Section hasNoContainer>
            <ContentBlock>
              <InputBlock
                label="Name"
                isRequired
                errorMessage={groupFormik.errors.name}
                inputState={`${helper.getInputClasses(groupFormik, 'name')}`}
                {...groupFormik.getFieldProps('name')}
              />
            </ContentBlock>
          </Section>
        </FormBlock>
      </ModalBlock>

      {/* GRADE MODAL */}
      <ModalBlock
        hasCloseAction
        centered
        isVisible={isGradeModalOpen}
        size="md"
        contentHeader={gradeModel.id === 0 ? 'Add New Grade' : 'Edit Grade'}
        primaryModalActionText={gradeModel.id === 0 ? 'Create' : 'Save Changes'}
        primaryModalActionColor="primary--bg"
        primaryModalActionOnClick={gradeFormik.handleSubmit}
        secondaryModalActionText="Cancel"
        secondaryModalActionColor="danger--bg"
        onHide={handleGradeModalClose}
      >
        <FormBlock onSubmit={gradeFormik.handleSubmit}>
          <Section hasNoContainer>
            <ContentBlock>
              <InputBlock
                label="Grade"
                isRequired
                inputState="disabled"
                {...gradeFormik.getFieldProps('group')}
              />
            </ContentBlock>
            <ContentBlock cols={6}>
              <InputBlock
                label="Generic Grade"
                isRequired
                errorMessage={gradeFormik.errors.genericGrade}
                inputState={`${helper.getInputClasses(gradeFormik, 'genericGrade')}`}
                {...gradeFormik.getFieldProps('genericGrade')}
              />
            </ContentBlock>
            <ContentBlock cols={6}>
              <InputBlock
                label="Mill Grade"
                isRequired
                errorMessage={gradeFormik.errors.millGrade}
                inputState={`${helper.getInputClasses(gradeFormik, 'millGrade')}`}
                {...gradeFormik.getFieldProps('millGrade')}
              />
            </ContentBlock>
          </Section>
        </FormBlock>
      </ModalBlock>
    </CustomBlock>
  );
};

const mapStateFromProps = (state) => ({ auth: state.auth });

export default connect(
  mapStateFromProps,
  {
    ...alert.actions,
    ...confirmModal.actions
  }
)(GroupListingPage);